module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('strong', [_vm._v("Note to the reader:")]), _vm._v(" This book describes how to help prevent infections in children "), _c('em', [_vm._v("in general.")]), _vm._v(" It was not written about "), _c('em', [_vm._v("your")]), _vm._v(" child. You should obtain the services of a competent professional whenever you need medical or other specific advice.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Dr. Kourtis’s work was performed outside the scope of her employment as a U.S. government employee. Her work represents her personal and professional views and not necessarily those of the U.S. Centers for Disease Control and Prevention.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2011 Athena P. Kourtis"), _c('br'), _vm._v("All rights reserved. Published 2011"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper"), _c('br'), _vm._v("2 4 6 8 9 7 5 3 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press"), _c('br'), _vm._v("2715 North Charles Street"), _c('br'), _vm._v("Baltimore, Maryland 21218-4363"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Kourtis, Athena P.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("Keeping your child healthy in a germ-filled world : a guide for parents / Athena P. Kourtis.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightvb"
  }, [_vm._v("p. cm. (A Johns Hopkins Press health book)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("ISBN-13: 978-1-4214-0211-6 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("ISBN-13: 978-1-4214-0212-3 (pbk. : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("ISBN-10: 1-4214-0211-4 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("ISBN-10: 1-4214-0212-2 (pbk. : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("1. Self-care, Health—Popular works. 2. Microorganisms—Popular works. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("RA776.95.K68 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightva"
  }, [_vm._v("613—dc22      2011004100")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Illustrations by Elizabeth Allen")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book."), _c('br'), _vm._v("For more information, please contact Special Sales"), _c('br'), _vm._v("at 410-516-6936 or specialsales@press.jhu.edu.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press uses environmentally friendly"), _c('br'), _vm._v("book materials, including recycled text paper that is composed of at"), _c('br'), _vm._v("least 30 percent post-consumer waste, whenever possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0